// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"7cf928c1","99":"4629f878","178":"fa8ad217","385":"225347d7","415":"043860ca","453":"d202e3ff","667":"b1987543","729":"5c32b935","752":"dc948a3c","832":"a57ce957","977":"cf6cf827"}[chunkId] + ".chunk.js";
};